var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12985",
    "data-name": "Path 12985",
    d: "M18.723,15.146a1.333,1.333,0,0,1,1.386.1l9.332,6.666a1.333,1.333,0,0,1,0,2.17L20.109,30.75A1.333,1.333,0,0,1,18,29.664V16.333A1.333,1.333,0,0,1,18.723,15.146Z",
    transform: "translate(-18 -14.999)",
    fill: "#00bb25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayGreen);
export default __webpack_public_path__ + "static/media/playGreen.6fa739a73ccae7c7e681cf7e8e22a961.svg";
export { ForwardRef as ReactComponent };